<millad-header [ngClass]="{'unblurred': !headerBlur}"></millad-header>
<router-outlet></router-outlet>
<millad-footer></millad-footer>